import { apiClient, FetchResponse } from '../utils/api';
import { ChatHistory, ChatThread, PaginatedChatHistory } from '../types';
import { ApiResponse } from '../types';


export const chatService = {
  sendMessageToThread: async (message: string, threadId: string): Promise<any> => {
    const response = await apiClient.post(`/api/chat/${threadId}/message`, {
      message,
      thread_id: threadId,
    });
    return response.data;
  },

  getThreadMessages: async (threadId: string): Promise<any> => {
    const response = await apiClient.get(`/api/chat/${threadId}`);
    return response;
  },

  getChatHistory: async (page: number = 1, pageSize: number = 100): Promise<FetchResponse<PaginatedChatHistory>> => {
    const response = await apiClient.get<PaginatedChatHistory>(`/api/chat/history?page=${page}&page_size=${pageSize}`);
    return response;
  },
  
  sendMessage: async (message: string, threadId: string): Promise<any> => {
    const response = await apiClient.post('/api/chat', {
      message,
      thread_id: threadId
    });
    return response;
  },

  uploadRfiFile: async (file: File): Promise<any> => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post('/api/rfi/upload', formData);
  },

  uploadKnowledgeFile: async (file: File): Promise<any> => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post('/api/knowledge/upload', formData);
  },
  
  getRfiChatThread: async (threadId: string): Promise<any> => {
    const response = await apiClient.get(`/api/rfi/chat/${threadId}`);
    return response;
  },

  addKnowledge: async (knowledgeData: { text: string; tag: string; type: string }): Promise<any> => {
    const response = await apiClient.post('/api/knowledge/add', 
      { 
        knowledge: knowledgeData.text,
        tag: knowledgeData.tag,
        type_: knowledgeData.type
      },
    );
    return response;
  },

  addKnowledgeFile: async (filename: string, knowledgeData: { tag?: string; type: string; parsing_strategy: string; auto_suggest_tag?: boolean }): Promise<any> => {
    const response = await apiClient.post('/api/knowledge/add-file',

      {
        filename: filename,
        tag: knowledgeData.tag,
        type_: knowledgeData.type,
        parsing_strategy: knowledgeData.parsing_strategy,
        auto_suggest_tag: knowledgeData.auto_suggest_tag
      }
    );
    return response;
  },

  validateTag: async (fileUuid: string, proposedTag: string): Promise<any> => {
    const response = await apiClient.post('/api/knowledge/validate-tag', {
      file_uuid: fileUuid,
      proposed_tag: proposedTag
    });
    return response.data;
  },

  confirmTag: async (fileUuid: string, finalTag: string, userOverrideSuggestion: boolean): Promise<any> => {
    const response = await apiClient.post('/api/knowledge/confirm-tag', {
      file_uuid: fileUuid,
      final_tag: finalTag,
      user_overrode_suggestion: userOverrideSuggestion
    });
    return response.data;
  },

  getCitationPdf: async (citationId: string): Promise<Blob> => {
    // Use the API client which handles token automatically
    const response = await apiClient.get(`/api/chat/citation/${citationId}`, {
      responseType: 'blob'
    });
    return response.data as Blob;
  },

  getCitationDetails: async (citationId: string): Promise<any> => {
    const response = await apiClient.get(`/api/chat/citation/${citationId}`);
    return response.data;
  },

  getChatMeta: async (): Promise<any> => {
    const response = await apiClient.get('/api/chat/meta');
    return response.data;
  },

  getKnowledgeFileStatus: async (fileUuid: string): Promise<any> => {
    const response = await apiClient.get(`/api/knowledge/${fileUuid}/status`);
    return response.data;
  },
}; 